import { Component, Vue, Ref } from "vue-property-decorator";
import LeftTree from '../components/LeftTree.vue'
import OperationBody from './components/OperationBody'
import './components/operation.less'
import { StatisticsServiceProxy } from '@/service-proxies/app-v2/mdc.service-proxies'
const stsp = new StatisticsServiceProxy()
const search = {
  1: stsp.operationStatisticsRps.bind(stsp), // 设备对比
  2: stsp.operationStatisticsRps2.bind(stsp) // 时间对比
}

enum map {
  SHIFT = 1,
  DAY,
  WEEK,
  MONTH
}

@Component({
  components: {
    LeftTree,
    OperationBody
  }
})
export default class OperationStatistics extends Vue {
  operationData = {"columns": [],"items": []}
  loading = false
  filter = {}
  showType = 1
  params:any = {}
  workStationList = []
  shiftList = []

  search() {
    this.loading = true
    this.operationData = {"columns": [],"items": []}
    const params = {
      ...this.params,
      showType: this.showType,
      statisticalMethod: map[this.params.statisticalMethod]
    }
    let getStandardEfficiency = (data) => {
      if (data)
        return this.params.workStationList.find(item => item.key === data).standardEfficiency
    }
    this.filter = {...params}
    search[this.showType](params).then(res => {
      let {items, columns} = res as any
      if(!columns || columns.length === 0) {
        return this.loading = false
      }
      for(const column of columns) {
        for (const item of items) {

          if(!item.data) item.data = {}
          if(this.showType === 1) { // 设备对比
            item.standardEfficiency = getStandardEfficiency(item.workStationId) || null
            if (!item.data.hasOwnProperty(column.code)) {
              item.data[column.code] = 0
            }
          } else { // 时间对比
            item.standardEfficiency = {}
            params.workStationList.map(w=>{
              item.standardEfficiency[w.key] = w.standardEfficiency
            })
            if (!item.data.hasOwnProperty(column.id)) {
              item.data[column.id] = 0
            }
          }
        }
      }

      // console.log(items)
      if(this.showType === 1) { // 设备对比
        let arr = [];
        for (var i = 0; i < params.workStationList.length; i++) {
          for (var j = 0; j < res.items.length; j++) {
            if (params.workStationList[i].key == res.items[j].workStationId) {
              arr.push(res.items[j])
            }
          }
        }
        items = arr;
      } else {
        columns.sort((a,b)=>{
          return a.id - b.id
        })
      }

      this.operationData = {
        items,
        columns,
      }

      this.loading = false
    })
  }

  outPut() {

  }

  changeX(){

  }

  // 切换查询模式
  toggleSearchType(type) {
    this.showType = type
    this.search()
  }

  getData(value) {
    this.params = value
    this.workStationList = value.workStationList
    this.search()
  }


  leftTree() {
    return (
      <left-tree init={['productivity','statistical','shift','time','Tree.vue']} onSearch={value => this.getData(value)} onGetShiftList={value=>this.shiftList = value} onOutPut={() => this.outPut()} queryKey="zhxl"></left-tree>
    )
  }
  operationBody() {
    return (
      <operation-body filter={this.filter} loading={this.loading} data={this.operationData.items} shiftList={this.shiftList} onToggleSearchType={value => this.toggleSearchType(value)} searchType={this.showType} columns={this.operationData.columns}></operation-body>
    )
  }
  render() {
    return (
      <a-layout class="operationStatistics-body" style="height: 100%">
        <a-layout-sider width="360" style="background: #fff; min-width:360px; overflow:auto;" class="no-fix-sider">
          {this.leftTree()}
        </a-layout-sider>
        <div v-resize={'x'}></div>
        <a-layout-content style={{ height: '100%' }}>
          { this.operationBody() }
        </a-layout-content>
      </a-layout>
    )
  }
}
